export default __webpack_public_path__ + "static/SR France - FSSC22000 - Certificate-0050fdc0f13a7aba52cc8a1eea2df67a.pdf";